import React from 'react';
import PropTypes from 'prop-types';
import { ArrayOfId, MasterEntityType } from '../../propTypes';
import ContactsFormGrid from '../contacts/ContactsFormGrid';
import { CONTACT_COLUMNS } from '../../constants/contact-columns';

const ContactList = ({
  masterEntity,
  contactType,
  showAllContactTypes,
  setSelectedContactIds,
  selectedContactIds,
  columns,
  checkbox,
  allContactsWarningMessage,
}) => (
  <ContactsFormGrid
    contactType={contactType}
    masterEntity={masterEntity}
    checkbox={checkbox}
    showAllContactTypes={showAllContactTypes}
    selectedContacts={selectedContactIds}
    setSelectedContact={setSelectedContactIds}
    columns={columns}
    allContactsWarningMessage={allContactsWarningMessage}
  />
);

ContactList.propTypes = {
  setSelectedContactIds: PropTypes.func.isRequired,
  contactType: PropTypes.string,
  masterEntity: MasterEntityType,
  showAllContactTypes: PropTypes.bool,
  selectedContactIds: ArrayOfId.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  columns: PropTypes.array,
  checkbox: PropTypes.bool,
  allContactsWarningMessage: PropTypes.string,
};

ContactList.defaultProps = {
  masterEntity: null,
  showAllContactTypes: false,
  contactType: null,
  columns: CONTACT_COLUMNS,
  checkbox: true,
  allContactsWarningMessage: null,
};

export default ContactList;
